/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

var c = require("@lexical/utils"),
    x = require("lexical");

function y(b, a, l, h, n) {
  if (null === b || 0 === l.size && 0 === h.size && !n) return 0;
  var f = a._selection,
      d = b._selection;
  if (n) return 1;
  if (!(x.$isRangeSelection(f) && x.$isRangeSelection(d) && d.isCollapsed() && f.isCollapsed())) return 0;
  n = a._nodeMap;
  var e = [];

  var _iterator = _createForOfIteratorHelper(l),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var m = _step.value;
      l = n.get(m), void 0 !== l && e.push(l);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(h),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref3 = _step2.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var _m = _ref2[0];
      var p = _ref2[1];
      p && (h = n.get(_m), void 0 === h || x.$isRootNode(h) || e.push(h));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (0 === e.length) return 0;
  if (1 < e.length) return h = a._nodeMap, a = h.get(f.anchor.key), d = h.get(d.anchor.key), a && d && !b._nodeMap.has(a.__key) && x.$isTextNode(a) && 1 === a.__text.length && 1 === f.anchor.offset ? 2 : 0;
  a = e[0];
  b = b._nodeMap.get(a.__key);
  if (!x.$isTextNode(b) || !x.$isTextNode(a) || b.__mode !== a.__mode) return 0;
  b = b.__text;
  a = a.__text;
  if (b === a) return 0;
  f = f.anchor;
  d = d.anchor;
  if (f.key !== d.key || "text" !== f.type) return 0;
  f = f.offset;
  d = d.offset;
  b = a.length - b.length;
  return 1 === b && d === f - 1 ? 2 : -1 === b && d === f + 1 ? 3 : -1 === b && d === f ? 4 : 0;
}

function z(b, a) {
  var l = Date.now(),
      h = 0;
  return function (n, f, d, e, m, p) {
    var r = Date.now();
    if (p.has("historic")) return h = 0, l = r, 2;

    var q = y(n, f, e, m, b.isComposing()),
        v = function () {
      var k = null === d || d.editor === b,
          g = p.has("history-push");
      if (!g && k && p.has("history-merge")) return 0;
      if (null === n) return 1;
      var t = f._selection;
      if (!(0 < e.size || 0 < m.size)) return null !== t ? 0 : 2;
      if (!1 === g && 0 !== q && q === h && r < l + a && k) return 0;

      if (1 === e.size) {
        {
          g = Array.from(e)[0];
          k = n._nodeMap.get(g);
          g = f._nodeMap.get(g);
          t = n._selection;
          var u = f._selection,
              w = !1;
          x.$isRangeSelection(t) && x.$isRangeSelection(u) && (w = "element" === t.anchor.type && "element" === t.focus.type && "text" === u.anchor.type && "text" === u.focus.type);
          k = !w && x.$isTextNode(k) && x.$isTextNode(g) ? k.__type === g.__type && k.__text === g.__text && k.__mode === g.__mode && k.__detail === g.__detail && k.__style === g.__style && k.__format === g.__format && k.__parent === g.__parent : !1;
        }
        if (k) return 0;
      }

      return 1;
    }();

    l = r;
    h = q;
    return v;
  };
}

exports.createEmptyHistoryState = function () {
  return {
    current: null,
    redoStack: [],
    undoStack: []
  };
};

exports.registerHistory = function (b, a, l) {
  var h = z(b, l);

  l = function l(_ref4) {
    var d = _ref4.editorState,
        e = _ref4.prevEditorState,
        m = _ref4.dirtyLeaves,
        p = _ref4.dirtyElements,
        r = _ref4.tags;
    var q = a.current,
        v = a.redoStack,
        k = a.undoStack,
        g = null === q ? null : q.editorState;

    if (null === q || d !== g) {
      e = h(e, d, q, m, p, r);
      if (1 === e) 0 !== v.length && (a.redoStack = [], b.dispatchCommand(x.CAN_REDO_COMMAND, !1)), null !== q && (k.push(_objectSpread({}, q)), b.dispatchCommand(x.CAN_UNDO_COMMAND, !0));else if (2 === e) return;
      a.current = {
        editor: b,
        editorState: d
      };
    }
  };

  var n = c.mergeRegister(b.registerCommand(x.UNDO_COMMAND, function () {
    var d = a.redoStack,
        e = a.undoStack;

    if (0 !== e.length) {
      var m = a.current,
          p = e.pop();
      null !== m && (d.push(m), b.dispatchCommand(x.CAN_REDO_COMMAND, !0));
      0 === e.length && b.dispatchCommand(x.CAN_UNDO_COMMAND, !1);
      a.current = p || null;
      p && p.editor.setEditorState(p.editorState, {
        tag: "historic"
      });
    }

    return !0;
  }, x.COMMAND_PRIORITY_EDITOR), b.registerCommand(x.REDO_COMMAND, function () {
    var d = a.redoStack;
    var e = a.undoStack;

    if (0 !== d.length) {
      var m = a.current;
      null !== m && (e.push(m), b.dispatchCommand(x.CAN_UNDO_COMMAND, !0));
      e = d.pop();
      0 === d.length && b.dispatchCommand(x.CAN_REDO_COMMAND, !1);
      a.current = e || null;
      e && e.editor.setEditorState(e.editorState, {
        tag: "historic"
      });
    }

    return !0;
  }, x.COMMAND_PRIORITY_EDITOR), b.registerCommand(x.CLEAR_EDITOR_COMMAND, function () {
    a.undoStack = [];
    a.redoStack = [];
    a.current = null;
    return !1;
  }, x.COMMAND_PRIORITY_EDITOR), b.registerCommand(x.CLEAR_HISTORY_COMMAND, function () {
    a.undoStack = [];
    a.redoStack = [];
    a.current = null;
    b.dispatchCommand(x.CAN_REDO_COMMAND, !1);
    b.dispatchCommand(x.CAN_UNDO_COMMAND, !1);
    return !0;
  }, x.COMMAND_PRIORITY_EDITOR), b.registerUpdateListener(l)),
      f = b.registerUpdateListener(l);
  return function () {
    n();
    f();
  };
};